import { MenuDivider, MenuItem } from '@rulebooks/evidend-titan';

export interface ActionOption {
  label?: string;
  onClick?: () => any;
  href?: string;
  isDisabled?: boolean;
  isDivider?: boolean;
  variant?: 'primary' | 'danger';
}
export const mapOptionsToActionMenuItems = (options: ActionOption[]) =>
  options.map((option, index) => {
    if (option.isDivider) return <MenuDivider key={index} />;
    return (
      <MenuItem
        key={option.label}
        item={{
          value: option.label,
          label: option.label || '',
        }}
        {...option}
      />
    );
  });
